import { render, staticRenderFns } from "./recyclingMachineList.vue?vue&type=template&id=dbf252d8&scoped=true&"
import script from "./recyclingMachineList.vue?vue&type=script&lang=js&"
export * from "./recyclingMachineList.vue?vue&type=script&lang=js&"
import style0 from "./recyclingMachineList.vue?vue&type=style&index=0&id=dbf252d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbf252d8",
  null
  
)

export default component.exports